export default st => `
          <button type="button" class="btn-1">${st.Buttons.one}</button>
          <button type="button" class="btn-2">${st.Buttons.two}</button>
          <button type="button" class="btn-3">${st.Buttons.three}</button>`;
